export const URLAPISUBIDA = 'https://sonarsaludocupacional.com/notis/subirimg.php'

export const URLAPISUBIDAPDF = 'https://sonarsaludocupacional.com/notis/subirpdf.php'
export const URLCARPETADESTINO = 'https://sonarsaludocupacional.com/notis/'

export const URLCARPETADESTINOPDF = 'https://sonarsaludocupacional.com/notis/'